<template>
  <div class="auth-login">
    <div>
      <div class="heading-4 black--text">
        Log in. <br />
        Yield smarter with an Unagii Account.
      </div>
      <div class="mt-10">
        <div class="d-flex align-center">
          <v-icon small color="primary">fa-check-circle</v-icon>
          <div class="text-4 darkgray--text ml-3">
            Instant access to consolidated portfolio across products anywhere
          </div>
        </div>
        <div class="d-flex align-center mt-3">
          <v-icon small color="primary">fa-check-circle</v-icon>
          <div class="text-4 darkgray--text ml-3">
            Stay updated with latest news and exclusive notifications
          </div>
        </div>
        <div class="d-flex align-center mt-3">
          <v-icon small color="primary">fa-check-circle</v-icon>
          <div class="text-4 darkgray--text ml-3">
            Potential to earn campaign bonuses
          </div>
        </div>
      </div>
      <form @submit.prevent="login">
        <div class="mt-8">
          <v-text-field
            id="email"
            outlined
            single-line
            class="c-input"
            placeholder="Email address"
            v-model="form.email"
            hide-details="auto"
          />
          <v-text-field
            id="password"
            autofocus
            v-model="form.password"
            :append-icon="showPwd ? 'far fa-eye' : 'far fa-eye-slash'"
            :type="showPwd ? 'text' : 'password'"
            @click:append="showPwd = !showPwd"
            outlined
            single-line
            class="c-input mt-3"
            placeholder="Password"
            hide-details="auto"
          ></v-text-field>
        </div>
        <div v-show="!!loginState.reCaptchaRequired" class="mt-4">
          <div :id="recaptchaElementId"></div>
        </div>
        <div
          class="d-flex flex-column flex-sm-row align-sm-center justify-sm-space-between"
        >
          <v-checkbox
            v-model="form.keepLoggedIn"
            label="Keep me logged in (14 days)"
          ></v-checkbox>
          <div class="text-5 primary--text clickable" @click="forgetPassword">
            Forgot Password?
          </div>
        </div>
        <div class="error--text mb-4" v-if="loginState.error">
          {{ loginState.error.message }}
        </div>
        <div class="mt-1">
          <input type="submit" class="d-none" />
          <c-btn @click="login" :loading="loginState.isLoggingIn" class="width-100">Log In</c-btn>
        </div>
      </form>
      <div class="mt-5 text-6 gray--text text-center ml-3 mr-3">
        or
      </div>
      <div class="mt-5">
        <social-auth />
      </div>
      <div class="mt-5 text-6 darkgray--text text-center">
        By logging in, you agree to Unagii’s
        <a
          href="https://www.unagii.com/legal/terms"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-none"
          >Terms & Conditions</a
        >
        and
        <a
          href="https://www.unagii.com/legal/privacy"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-none"
          >Privacy Policy</a
        >.
      </div>
    </div>
    <div>
      <v-divider class="mt-10 mb-10"></v-divider>
      <continue-anonymously @showConnectWallet="$emit('showConnectWallet')" />
    </div>
    <div class="mt-10">
      <protect-statement />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SocialAuth from "./SocialAuth";
import ContinueAnonymously from "./ContinueAnonymously";
import ProtectStatement from "./ProtectStatement";

export default {
  components: {
    SocialAuth,
    ContinueAnonymously,
    ProtectStatement,
  },
  props: ["email"],
  data: () => ({
    showPwd: false,
    loading: false,
    recaptchaElementId: "c-recaptcha",
    form: {
      email: "",
      password: "",
      keepLoggedIn: true,
    },
  }),
  computed: {
    ...mapGetters({
      loginState: "auth/login",
    }),
    isFormValid() {
      return (
        String(this.form.email).trim() && String(this.form.password).trim()
      );
    },
  },
  methods: {
    async login() {
      if (!this.isFormValid) return;
      const payload = { ...this.form };
      if (this.loginState.reCaptchaRequired) {
        payload.recaptchaResponse = getUserResponse();
      }
      await this.$store.dispatch("auth/login", payload);
      if (!this.loginState.error) {
        this.$store.dispatch("closeAuthModal");
        this.$store.dispatch("addAlert", {
          type: "success",
          title: "auth.login.success.title",
          message: "auth.login.success.message",
        });
      }
      if (!this.recaptchaEnabled && this.loginState.reCaptchaRequired) {
        this.enableRecaptcha();
      }
      if (this.recaptchaEnabled && payload.recaptchaResponse) {
        window.grecaptcha.reset();
      }
    },
    enableRecaptcha() {
      if (window.grecaptcha && "function" === typeof window.grecaptcha.render) {
        window.grecaptcha.render(this.recaptchaElementId, {
          sitekey: this.loginState.recaptchaSiteKey,
        });
        this.recaptchaEnabled = true;
      }
    },
    forgetPassword() {
      this.$emit("setComponent", "ForgottenPassword");
    },
  },
  mounted() {
    this.form.email = this.email;
  },
};
</script>
